export function StatusBadge({ status }) {
  const labels = { termine: "Terminé", a_verifier: "À vérifier", erreur: "Erreur", en_cours: "En cours", connectee: "Connectée", en_pause: "En pause", non_configuree: "Non configurée", a_tester: "À tester" };
  const key = status || "non_configuree";
  return <span className={`status-badge status-${key}`} data-testid={`status-${key}`}>{labels[key] || key}</span>;
}